<template>
    <nav id="menu" :class="{open: isOpen}">
        <ul>                        
            <MenuItem v-for="(item, index) in menuItems" v-bind:key="index" :to="item.to" :text="item.text"/>
        </ul>
    </nav>
</template>

<script>
    import MenuItem from "./MenuItem";

    export default {
        name: 'Menu',
        components: {MenuItem},
        props: {
            menuItems: {
                type: Array,
                default: function () { return [
                    { text: "default", to: {path:'/'} }
                ]}
            }
        },
        computed: {
            isOpen() {
                return this.$store.state.menu.open;
            }
        }
    };
</script>

<style scoped>
    
    #menu {background: #3C3F41; position: fixed; right: -16rem; top: 2.75rem; bottom: 0; width: 16rem; transition: .25s; z-index: 9999; box-shadow: -.2rem 0rem .75rem 0px rgba(0,0,0,0);}
    #menu.open {right: 0rem; box-shadow: -.2rem 0rem .75rem 0px rgba(0,0,0,0.25);}
        #menu > ul {padding: 0; margin: 0; list-style: none;}
    
</style>